import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-slate-200/80 bg-white py-5"
    >
      <div className="flex w-max animate-marquee items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-heading text-sm font-semibold uppercase tracking-[0.25em] text-navy-900/70">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-sky-400" />
          </span>
        ))}
      </div>
    </div>
  );
};
